import React from 'react';
import { useBrandLocation } from 'src/hooks/useBrandLocation';
import { BrandLocation } from 'src/constans/branding';
import { getBrandByLocation } from 'src/utils/getBrandByLocation';

import { CatalystLogo } from './CatalystLogo';
import {
  BrandLogoImage,
  BrandLogoWrapper,
  EngageLogoContainer,
  TopBrandLogoContainer,
} from './BrandLogo.styled';
import GeorgetownLogo from './GeorgetownLogo.png';
import RutgersLogo from './RutgersLogo.png';

interface Props {
  isMobile?: boolean;
  variant?: 'auth' | 'header';
  className?: string;
  showCampusLogo?: boolean;
}

export const BrandLogo = ({
  isMobile = false,
  variant = 'auth',
  className = 'default',
  showCampusLogo = true,
}: Props) => {
  const { brandLocation } = useBrandLocation();
  const brand = getBrandByLocation(brandLocation);

  return (
    <BrandLogoWrapper className={className}>
      {showCampusLogo && brand.key !== 'default' && (
        <TopBrandLogoContainer variant={variant}>
          {brand.key === BrandLocation.RUTGERS ? (
            <BrandLogoImage
              src={RutgersLogo}
              alt='Rutgers logo'
              isMobile={isMobile}
              variant={variant}
            />
          ) : brand.key === BrandLocation.GEORGETOWN ? (
            <BrandLogoImage
              src={GeorgetownLogo}
              alt='Georgetown logo'
              isMobile={isMobile}
              variant={variant}
            />
          ) : (
            <></>
          )}
        </TopBrandLogoContainer>
      )}
      <EngageLogoContainer
        isMobile={isMobile}
        variant={variant}
      >
        <CatalystLogo className='engageLogo' />
      </EngageLogoContainer>
    </BrandLogoWrapper>
  );
};
